export default __webpack_public_path__ + "assets/models/45a10317e8ff245411c3ac1b613010eb.gltf";